import momentJalaali from "moment-jalali";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Card, Col, FormGroup, Popover, Row } from "react-bootstrap";
import ModalImportFromExcel from "../../Pages/ModalImportFromExcel";
import BihamtaTable from "../../Components/BihamtaTable";
import { CheckLg, CloudUploadFill, DashCircle, Download, ExclamationTriangle, EyeFill, EyeSlashFill, FileEarmarkExcelFill, FileEarmarkX, Link45deg, List, Pencil, PencilFill, PlusCircle, Reply, Search, Trash } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faTimes } from "@fortawesome/free-solid-svg-icons";
import { addEditCard, saveCards, saveSubCards, searchCards, getAllGuaranteeHolders, deleteCard, deleteCards, updateCardsAgencyID } from "../store/api/GuaranteeApi";
import { useDispatch, useSelector } from "react-redux";
import { attachFile, deleteAttachment, downloadFile, exportToExcel, getAttachmentList, isWebApp, setErrorDialog } from "../../store/api/CommonFunctions";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalGuaranteeSubProducts from "../Components/ModalGuaranteeSubProducts";
import { setDialog } from "../store/api/GetAllProduct";
import { Alert, Table } from "react-bootstrap";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";

const GuaranteeCardsManagement = () => {
    // #region Constants
    const settingNames = ['ProductGrouppingType', 'GuaranteeCheck_UseProductCodeInEntringCards', 'GuaranteeCheck_GuaranteeNumberIsMandatoryInsteadOfSerialNumber'];
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm();
    const dateFilters = useRef({});
    const inputAttach = useRef();
    const [showFilter, setShowFilter] = useState(true);
    const [showImportExl, setShowImportExl] = useState(false);
    const [exlModalInfo, setExlModalInfo] = useState(null);
    const [currentCard, setCurrentCard] = useState(null);
    const currentCardID = useRef();
    const [popProduct, setPopProduct] = useState({ show: false });
    const [cancelConfirm, setCancelConfirm] = useState(false);
    const selectedRows = useRef([]);
    //const [dataList, setDataList] = useState({ Data: [] });
    const [pending, setPending] = useState(false);
    const [holderList, setHolderList] = useState(null);
    const [modalSubProducts, setModalSubProducts] = useState({ show: false });
    const [attachList, setAttachList] = useState(null);
    const currentHolder = useRef(-1);
    const [popAgency, setPopAgency] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const filterData = useSelector(state => state.guaranteeCardsReducer.gCardsFilters);
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const [popStaff, setPopStaff] = useState({ show: false });
    const pgType = Array.isArray(systemSettings ?? "") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;
    const useProductCode = Array.isArray(systemSettings ?? "") ?
        systemSettings.find(s => s.SettingName === "GuaranteeCheck_UseProductCodeInEntringCards")?.SettingValue?.toLowerCase() === "true" : false;
    const gCardNoIsRequired = Array.isArray(systemSettings ?? "") ?
        systemSettings.find(s => s.SettingName === "GuaranteeCheck_GuaranteeNumberIsMandatoryInsteadOfSerialNumber")?.SettingValue?.toLowerCase() === "true" : false;
    const exlFields = [
        { DatabaseName: "GuaranteeCardNo", DisplayName: "شماره گارانتی" },
        { DatabaseName: "SerialNumber", DisplayName: "شماره سریال" },
        { DatabaseName: "CardPrice", DisplayName: "هزینه کارت" },
        { DatabaseName: "CustomerCode", DisplayName: "کد مشتری" },
        { DatabaseName: "PGuaranteeStartDate", DisplayName: "آغاز گارانتی" },
        { DatabaseName: "PGuaranteeEndDate", DisplayName: "پایان گارانتی" },
        { DatabaseName: "PPurchaseDate", DisplayName: "تاریخ خرید" },
        { DatabaseName: "PProductCreationDate", DisplayName: "تاریخ تولید" },
        { DatabaseName: "ShopName", DisplayName: "نام فروشگاه" },
        { DatabaseName: "Description", DisplayName: "توضیحات" },
        { DatabaseName: "CustomerDescription", DisplayName: "اظهارات مشتری" },
        { DatabaseName: "AgentCode", DisplayName: "کد نمایندگی" },
        { DatabaseName: "Manufacturer", DisplayName: "تولید کننده" },
        { DatabaseName: "ProductionOperator", DisplayName: "اپراتور تولید" }

    ]
    const subProductsExlFields = [
        { DatabaseName: "SerialNumber", DisplayName: "شماره سریال قطعه" },
        { DatabaseName: "PGuaranteeStartDate", DisplayName: "آغاز گارانتی" },
        { DatabaseName: "PGuaranteeEndDate", DisplayName: "پایان گارانتی" },
    ]
    if (useProductCode) {
        exlFields.push({ DatabaseName: "ProductCode", DisplayName: "کد محصول" });
        subProductsExlFields.push({ DatabaseName: "ProductCode", DisplayName: "کد قطعه" });
        subProductsExlFields.push({ DatabaseName: "MainProductCode", DisplayName: "کد محصول" });
    }
    else {
        exlFields.push(
            { DatabaseName: "ProductName", DisplayName: "نام/نوع محصول" },
            { DatabaseName: "ProductModel", DisplayName: "مدل محصول" })
        subProductsExlFields.push(
            { DatabaseName: "ProductHolderName", DisplayName: "مارک قطعه" },
            { DatabaseName: "ProductName", DisplayName: "نام/نوع قطعه" },
            { DatabaseName: "ProductModel", DisplayName: "مدل قطعه" }
        )
    }
    if (gCardNoIsRequired) {
        subProductsExlFields.push({ DatabaseName: "GuaranteeCardNo", DisplayName: "شماره گارانتی محصول" });
    }
    else {
        subProductsExlFields.push({ DatabaseName: "MainSerialNumber", DisplayName: "شماره سریال محصول" });
    }

    const tableCols = [
        { colTitle: "انتخاب", colName: "select", colType: "boolean", editable: true, onChange: selectRow, selectAll: selectAllRows },
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "شماره گارانتی", colName: "GuaranteeCardNo", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "شماره سریال", colName: "SerialNumber", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "شناسه رهگیری", colName: "MIMTTrackingID" },
        { colTitle: "کد محصول", colName: "ProductCode" },
        { colTitle: "نام/نوع محصول", colName: "ProductName" },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "هزینه کارت", colName: "CardPrice", colType: "currency" },
        { colTitle: "آغاز گارانتی", colName: "PGuaranteeStartDate" },
        { colTitle: "پایان گارانتی", colName: "PGuaranteeEndDate" },
        { colTitle: "تاریخ خرید", colName: "PPurchaseDate" },
        { colTitle: "تاریخ تولید", colName: "PProductCreationDate" },
        { colTitle: "نام فروشگاه", colName: "ShopName" },
        { colTitle: "نام نماینده", colName: "AgencyName" },
        { colTitle: "نام مشتری", colName: "CustomerName" },
        { colTitle: "استفاده شده", colName: "IsUsedInServices", colType: "boolean" },
        { colTitle: "فروش رفته", colName: "IsActive", colType: "boolean" },
        { colTitle: "رسید دارد", colName: "HasInvoice", colType: "boolean" },
        { colTitle: "خارج از گارانتی", colName: "IsGuaranteeCanceled", colType: "boolean" },
        { colTitle: "شرح ابطال", colName: "CancelDescription" },
        { colTitle: "تاریخ ثبت", colName: "PCreationDate" },
        { colTitle: "", colName: "CardID", style: { display: "none" }, headerStyle: { display: "none" } }
    ]
    //#endregion    
    function selectRow(row) {
        const cardID = Number(row.CardID);
        if (row.e.target.checked) {
            if (!selectedRows.current.includes(cardID)) {
                selectedRows.current.push(cardID);
            }
        }
        else {
            selectedRows.current = selectedRows.current.filter(r => r !== cardID);
        }
    }
    function selectAllRows(e) {

        selectedRows.current = [];
        const table = e.target.closest("table");
        table.style.display = "none";
        for (let i = 1; i < table.rows.length; i++) {
            const row = table.rows[i];
            //خط زیر کد را کندتر می کند بنابراین حذف شد
            //const firstChild = Array.from(row.cells).find(c=>c.getAttribute("colname") === "select");
            for (let j = 0; j < row.cells.length; j++) {
                if (row.cells[j]?.getAttribute("colname") === "select") {
                    const firstChild = row.cells[j].firstChild;
                    if (firstChild?.type === "checkbox") {
                        firstChild.checked = e.target.checked;
                    }
                }
                if (row.cells[j]?.getAttribute("colname") === "CardID") {
                    if (e.target.checked) {
                        const cardID = Number(row.cells[j].firstChild.nodeValue);
                        if (cardID > 0) {
                            selectedRows.current.push(cardID);
                        }
                    }
                }
            }
        }
        table.style.display = "table";
    }
    function loadAttachList(row) {
        currentCardID.current = row.CardID;
        getAttachmentList(row.CardID, "GuaranteeCardAttachment", setAttachList);

    }
    function delAttach(id) {
        dispatch(deleteAttachment(id, "DocumentAttachment", () => getAttachmentList(currentCardID.current, "GuaranteeCardAttachment", setAttachList)));
    }
    function attach() {
        dispatch(attachFile(inputAttach.current, currentCardID.current, "GuaranteeCardAttachment", () => getAttachmentList(currentCardID.current, "GuaranteeCardAttachment", setAttachList)));
    }
    const popAttachments = (
        (<Popover id="popAttachments" style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Button className="btn-input-tiny" style={{ top: "1px", left: "1px" }} onClick={attach}><CloudUploadFill size={25} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>تاریخ پیوست</th>
                            <th style={{ width: "50%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "65%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "GuaranteeCardAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    const rowButtons = [
        { type: "common", title: "ویرایش کارت", icon: <PencilFill color="orange" size={18} className="rowBtn"/>, onclick: showPopEditCard },
        { type: "overlay", tooltip: "پیوست ها", overlay: popAttachments, onclick: loadAttachList, icon: <Link45deg color="blue" size={18} className="rowBtn"/> },
        { type: "common", tooltip: "فهرست قطعات", title: "فهرست قطعات", icon: <List color="green" size={18} className="rowBtn"/>, onclick: showSubProducts },
        {
            type: "delete", title: "حذف گارانتی", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف گارانتی',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteC(item)
                }))
            },
            showCondition: (row) => !row.IsUsedInServices && !row.IsGuaranteeCanceled
        }
    ]
    function showSubProducts(row) {
        setModalSubProducts({
            cardID: row.CardID,
            show: true,
            productName: row.ProductName,
            productModel: row.ProductModel,
            serialNumber: row.SerialNumber
        })
    }
    function toExcel() {
        const url = "api/GuarantyAPI/SearchCards";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("SearchGuaranteeCards", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function showModalImportExl() {
        if (!(Number(currentHolder.current) > 0)) {
            setErrorDialog(dispatch, "برندی انتخاب نشده است", "دریافت از اکسل");
            return;
        }
        const onSubmitData = (data, checkUpdate, saveCardData) => {
            for (let i = 0; i < data.length; i++) {
                if ((data[i].PProductCreationDate) ?? "") {
                    if (!momentJalaali(data[i].PProductCreationDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ تولید در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].ProductCreationDate = momentJalaali(data[i].PProductCreationDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PPurchaseDate) ?? "") {
                    if (!momentJalaali(data[i].PPurchaseDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ خرید در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].PurchaseDate = momentJalaali(data[i].PPurchaseDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PGuaranteeStartDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeStartDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ آغاز گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeStartDate = momentJalaali(data[i].PGuaranteeStartDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PGuaranteeEndDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeEndDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ پایان گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeEndDate = momentJalaali(data[i].PGuaranteeEndDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                data[i].HolderID = currentHolder.current;
                data[i].ServiceType = saveCardData.ServiceType;
            }
            //setDataList({ Data: data });
            setShowImportExl(false);
            const onSave = (res) => {
                if (res.Error) {
                    setErrorDialog(dispatch, res.Error, "دریافت از اکسل");
                }
                else {
                    setErrorDialog(dispatch, "success", "دریافت از اکسل");
                }
            }
            saveCards(data, saveCardData.SaveService ?? false, saveCardData.StorageID, onSave);
        }
        const modalInfo = {};
        modalInfo.formName = "GuaranteeCards";
        modalInfo.submitData = onSubmitData;
        modalInfo.pageFields = exlFields;
        setExlModalInfo(modalInfo);
        setShowImportExl(true);
    }
    function deleteC(row) {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف گارانتی");
            }
            else {
                dispatch(searchCards(filterData));
            }
        }
        deleteCard(row.CardID, onSuccess);
    }
    function deleteSelectedCards() {
        if (selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "حذف کارتهای گارانتی");
            return;
        }
        setPending(true);
        const onResponse = (res) => {
            setPending(false);
            if (res?.Error) {
                setErrorDialog(dispatch, res.Error, "حذف کارتهای گارانتی");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "حذف کارتهای گارانتی");
                selectedRows.current = [];
                dispatch(searchCards(filterData));
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف کارت گارانتی',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: () => deleteCards(selectedRows.current, onResponse)
        }))
    }
    function showModalImportExlForSub() {
        const onSubmitData = (data) => {
            for (let i = 0; i < data.length; i++) {
                if ((data[i].PGuaranteeStartDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeStartDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ آغاز گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeStartDate = momentJalaali(data[i].PGuaranteeStartDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if ((data[i].PGuaranteeEndDate) ?? "") {
                    if (!momentJalaali(data[i].PGuaranteeEndDate, 'jYYYY/jMM/jDD').isValid()) {
                        setErrorDialog(dispatch, `فرمت تاریخ پایان گارانتی در ردیف ${i + 1} درست نیست`, "دریافت از اکسل");
                        return;
                    }
                    data[i].GuaranteeEndDate = momentJalaali(data[i].PGuaranteeEndDate, "'jYYYY/jMM/jDD").format("YYYY-MM-DD");
                }
                if (useProductCode) {
                    if (!(data[i].ProductCode?.toString().length > 0)) {
                        setErrorDialog(dispatch, `کد قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                }
                else {
                    if (!(data[i].ProductName?.toString().length > 0)) {
                        setErrorDialog(dispatch, `نام/نوع قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                    if (!(data[i].ProductModel?.toString().length > 0)) {
                        setErrorDialog(dispatch, `مدل قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                    if (!(data[i].ProductHolderName?.toString().length > 0)) {
                        setErrorDialog(dispatch, `مارک قطعه در ردیف ${i + 1} وارد نشده است`, "دریافت از اکسل");
                        return;
                    }
                }
            }
            //setDataList({ Data: data });
            setShowImportExl(false);
            const onSave = (res) => {
                if (res.Error) {
                    setErrorDialog(dispatch, res.Error, "دریافت از اکسل");
                }
                else {
                    setErrorDialog(dispatch, "success", "دریافت از اکسل");
                }
            }
            saveSubCards(data, onSave);
        }
        const modalInfo = {};
        modalInfo.formName = "GuaranteeCards";
        modalInfo.submitData = onSubmitData;
        modalInfo.pageFields = subProductsExlFields;
        setExlModalInfo(modalInfo);
        setShowImportExl(true);
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        //Date Filters
        {
            selectedRows.current = [];
            let date = document.getElementsByName("CreateFromDate")[0].value;
            if (date !== "") {
                data.CreateFromDate = dateFilters.current.CreateFromDate;
            }
            else {
                dateFilters.current.CreateFromDate = null;
            }
            date = document.getElementsByName("CreateFromDate")[0].value;
            if (date !== "") {
                data.CreateFromDate = dateFilters.current.CreateFromDate;
            }
            else {
                dateFilters.current.CreateFromDate = null;
            }
            date = document.getElementsByName("GuaranteeStartFromDate")[0].value;
            if (date !== "") {
                data.GuaranteeStartFromDate = dateFilters.current.GuaranteeStartFromDate;
            }
            else {
                dateFilters.current.GuaranteeStartFromDate = null;
            }
            date = document.getElementsByName("GuaranteeStartToDate")[0].value;
            if (date !== "") {
                data.GuaranteeStartToDate = dateFilters.current.GuaranteeStartToDate;
            }
            else {
                dateFilters.current.GuaranteeStartToDate = null;
            }
            date = document.getElementsByName("GuaranteeEndFromDate")[0].value;
            if (date !== "") {
                data.GuaranteeEndFromDate = dateFilters.current.GuaranteeEndFromDate;
            }
            else {
                dateFilters.current.GuaranteeEndFromDate = null;
            }
            date = document.getElementsByName("GuaranteeEndToDate")[0].value;
            if (date !== "") {
                data.GuaranteeEndToDate = dateFilters.current.GuaranteeEndToDate;
            }
            else {
                dateFilters.current.GuaranteeEndToDate = null;
            }
            date = document.getElementsByName("ActiveFromDate")[0].value;
            if (date !== "") {
                data.ActiveFromDate = dateFilters.current.ActiveFromDate;
            }
            else {
                dateFilters.current.ActiveFromDate = null;
            }
            date = document.getElementsByName("ActiveToDate")[0].value;
            if (date !== "") {
                data.ActiveToDate = dateFilters.current.ActiveToDate;
            }
            else {
                dateFilters.current.ActiveToDate = null;
            }
            date = document.getElementsByName("PurchaseFromDate")[0].value;
            if (date !== "") {
                data.PurchaseFromDate = dateFilters.current.PurchaseFromDate;
            }
            else {
                dateFilters.current.PurchaseFromDate = null;
            }
            date = document.getElementsByName("PurchaseToDate")[0].value;
            if (date !== "") {
                data.PurchaseToDate = dateFilters.current.PurchaseToDate;
            }
            else {
                dateFilters.current.PurchaseToDate = null;
            }
        }
        ///////////
        if (!data.Take) {
            data.Take = 10;
        }
        data.HolderID = currentHolder.current;
        data.Skip = 0;
        dispatch(searchCards(data));
    }
    function showPopEditCard(card) {
        setCurrentCard(card);
    }
    function showModalProduct() {
        const onSetData = (data) => {
            if (data?.ProductID) {
                setCurrentCard({
                    ...currentCard,
                    ProductID: data.ProductID,
                    ProductCode: data.ProductCode,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel
                })
            }

        }
        setPopProduct({
            show: true,
            setProductData: onSetData
        })
    }
    function addEdit(confirmedCancel) {
        if (!confirmedCancel && currentCard.IsGuaranteeCanceled) {
            setCancelConfirm(true);
            return;
        }
        if (currentCard.IsUsedInServices && !currentCard.IsGuaranteeCanceled) {
            setErrorDialog(dispatch, "این کارت استفاده شده و امکان ویرایش آن وجود ندارد", "کارت گارانتی");
            return;
        }
        if ((currentCard.HolderID ?? "") === "" || (currentCard.ProductID ?? "") === "") {
            return;
        }
        const onAddEdit = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, (Number(currentCard.CardID) > 0 ? "ویرایش" : "ثبت") + ` کارت گارانتی`);
                setCancelConfirm(false);
                return;
            }
            else if (res.Data) {
                setCurrentCard(null);
                setCancelConfirm(false);
                setErrorDialog(dispatch, "success", (Number(currentCard.CardID) > 0 ? "ویرایش" : "ثبت") + " کارت گارانتی");
            }
            search(filterData ?? {});
        }
        const cardData = (({ e, ...data }) => data)(currentCard);
        cardData.ID = currentCard.CardID;
        addEditCard(cardData, cardData.StorageID, onAddEdit);
    }
    function prepareForAddEdit(e) {
        e.pageX -= 150;
        e.pageY += 20;
        setCurrentCard({ CardID: 0, e });
    }
    function addMonth(month) {
        if (currentCard.GuaranteeStartDate && currentCard.GuaranteeStartDate !== '') {
            const m = momentJalaali(currentCard.GuaranteeStartDate);
            const endDt = m.add("jMonth", Number(month));
            currentCard.GuaranteeTimeInMonth = month;
            setCurrentCard({ ...currentCard, GuaranteeEndDate: endDt.local("en").format("YYYY-MM-DD") });

        }
    }
    function calcG_TimeInMonth(date, isEnd) {
        if (isEnd) {
            currentCard.GuaranteeEndDate = date;
        }
        else {
            currentCard.GuaranteeStartDate = date;
        }
        const gStartDate = currentCard.GuaranteeStartDate;
        const gEndDate = currentCard.GuaranteeEndDate;
        if ((isEnd && (!gStartDate || gStartDate === '')) || (!isEnd && (!gEndDate || gEndDate === ''))) {
            return;
        }
        const endDate = isEnd ? new Date(date) : new Date(gEndDate);
        const startDate = isEnd ? new Date(gStartDate) : new Date(date);
        let months = endDate.getMonth() - startDate.getMonth()
            + (12 * (endDate.getFullYear() - startDate.getFullYear()));

        if (endDate.getDate() < startDate.getDate()) {
            months--;
        }
        setCurrentCard({ ...currentCard, GuaranteeTimeInMonth: months });

    }
    function showModalStorage(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            setCurrentCard({ ...currentCard, StorageID: data?.StorageID, StorageName: data?.StorageName });
        }
        setPopStorage({
            show: true,
            isStaffStorage: false,
            setStorageData: onSelectStorage
        })
    }
    function showModalAgency() {
        const onSelect = (res) => {
            setCurrentCard({ ...currentCard, AgencyID: res?.ID, AgencyName: res?.LastName })
        }
        setPopAgency({
            show: true,
            forAgency: true,
            onSelect: onSelect
        })
    }
    function assignToAgency(e) {
        if (selectedRows.current.length === 0) {
            setErrorDialog(dispatch, "کارتی انتخاب نشده است.", "تخصیص کارتهای گارانتی");
            return;
        }
        setPending(true);
        const onResponse = (res) => {
            setPending(false);
            if (res?.Error) {
                setErrorDialog(dispatch, res.Error, "تخصیص کارتهای گارانتی");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "تخصیص کارتهای گارانتی");
                selectedRows.current = [];
                dispatch(searchCards(filterData));
            }
        }
        const onSelect = (agency) => {
            if (agency)
                updateCardsAgencyID(selectedRows.current, agency.ID, onResponse);
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'تخصیص کارت',
            dialogText: 'آیا از تخصیص کارت مطمئن هستید؟',
            okOperation: () => setPopAgency({ show: true, forAgency: true, onSelect: onSelect })
        }))

    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        getAllGuaranteeHolders(null, setHolderList);
        dispatch(getSystemSettings(settingNames));
    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice=""
                defaultSalePriceLabel="" defaultStorages="" />
            <ModalSelectStaff setPopSelectStaff={setPopAgency} popData={popAgency} />
            {
                currentCard?.e &&
                <Popover id="popEditCard" style={{ fontSize: "13px", fontFamily: "Vazir", maxWidth: "400px", minWidth: "400px", left: currentCard.e.pageX + 15, top: currentCard.e.pageY - 300 }} className="mt-5">
                    <Popover.Title as="h3" className="headerStyle">
                        <span>  <FontAwesomeIcon icon={faClipboardList} size="lg" />&nbsp;{Number(currentCard.CardID) > 0 ? "ویرایش " : "ثبت "}  کارت گارانتی {Number(currentCard.InvoiceID) > 0 ? "[رسید دارد]" : ""}</span>
                        <label style={{ float: "left" }}><FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setCurrentCard(null)} /></label>
                        {Number(currentCard.CardID) > 0 &&
                            <div style={{ display: "inline-block", fontSize: "11px" }}>
                                {"["}
                                <span>تاریخ ثبت: </span>
                                <label>{currentCard.PCreationDate}</label>
                                {"]"}
                            </div>
                        }
                    </Popover.Title>
                    <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                        <table style={{ width: "100%", fontSize: "12px" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "100px" }}>نام برند:</td>
                                    <td colSpan="100%">
                                        {
                                            Array.isArray(holderList ?? "") ?
                                                <select className="tableRowInput" onChange={e => currentCard.HolderID = e.target.value} defaultValue={currentCard.HolderID}>
                                                    <option value="">انتخاب کنید</option>
                                                    {holderList.map((item, i) =>
                                                        <option key={i} value={item.ID}>{item.HolderName}</option>)
                                                    }
                                                </select> :
                                                <div className="tableRowInput">
                                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                                </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>نمایندگی: </td>
                                    <td colSpan="100%">
                                        <div>
                                            <input className="tableRowInput" value={currentCard.AgencyName ?? ""} readOnly />
                                            <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={showModalAgency}><List size={17} /></Button>
                                        </div>
                                    </td>
                                </tr>
                                {Number(currentCard.AgencyID) > 0 && currentCard.AssignToAgencyDate &&
                                    <tr>
                                        <td>تاریخ تخصیص به نمایندگی: </td>
                                        <td colSpan="100%">
                                            <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0"
                                                value={momentJalaali(currentCard.AssignToAgencyDate.substring(0, 10))} readOnly disabled />

                                        </td>
                                    </tr>
                                }
                                <tr>
                                    <td>مشخصات محصول: </td>
                                    <td colSpan="100%">
                                        <div>
                                            <input className="tableRowInput" value={(currentCard.ProductName ?? "") + "-" + (currentCard.ProductModel ?? "")} />
                                            <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={showModalProduct}><List size={17} /></Button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>شماره کارت/سریال: </td>
                                    <td colSpan={3}>
                                        <input className="tableRowInput" placeholder="شماره کارت" title="شماره کارت" defaultValue={currentCard.GuaranteeCardNo} onChange={e => currentCard.GuaranteeCardNo = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                    </td>
                                    <td colSpan={3}>
                                        <input className="tableRowInput" title="شماره سریال" placeholder="شماره سریال" defaultValue={currentCard.SerialNumber} onChange={e => currentCard.SerialNumber = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>نام فروشگاه: </td>
                                    <td colSpan="100%"><input className="tableRowInput" defaultValue={currentCard.ShopName ?? ""} onChange={e => currentCard.ShopName = e.target.value} /></td>
                                </tr>
                                <tr>
                                    <td>هزینه کارت: </td>
                                    <td colSpan="100%"><input className="tableRowInput" type="number" defaultValue={currentCard.CardPrice ?? ""} onChange={e => currentCard.CardPrice = e.target.value} /></td>
                                </tr>
                                <tr>
                                    <td>تاریخ و مدت:</td>
                                    <td colSpan={2}>
                                        <DatePicker timePicker={false} isGregorian={false} placeholder="آغاز گارانتی" className="tableRowInput mt-0"
                                            value={(currentCard.GuaranteeStartDate ?? "") !== "" ? momentJalaali(currentCard.GuaranteeStartDate.substring(0, 10)) : null}
                                            onChange={val => setCurrentCard({ ...currentCard, GuaranteeStartDate: val.local("en").format("YYYY-MM-DD") })} />
                                    </td>
                                    <td colSpan={2} ><input style={{ color: "blue" }} placeholder="مدت گارانتی" className="tableRowInput" type="number" onChange={e => addMonth(e.target.value)} value={currentCard.GuaranteeTimeInMonth ?? 0} /></td>
                                    <td colSpan={2}>
                                        <DatePicker timePicker={false} isGregorian={false} placeholder="پایان گارانتی" className="tableRowInput mt-0"
                                            value={(currentCard.GuaranteeEndDate ?? "") !== "" ? momentJalaali(currentCard.GuaranteeEndDate.substring(0, 10)) : null}
                                            onChange={val => setCurrentCard({ ...currentCard, GuaranteeEndDate: val.local("en").format("YYYY-MM-DD") })} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>تاریخ تولید/خرید: </td>
                                    <td colSpan="3">
                                        <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0" placeholder="تاریخ تولید"
                                            value={(currentCard.ProductCreationDate ?? "") !== "" ? momentJalaali(currentCard.ProductCreationDate.substring(0, 10)) : null}
                                            onChange={val => setCurrentCard({ ...currentCard, ProductCreationDate: val.local("en").format("YYYY-MM-DD") })} />
                                    </td>
                                    <td colSpan="3">
                                        <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0" placeholder="تاریخ خرید"
                                            value={(currentCard.PurchaseDate ?? "") !== "" ? momentJalaali(currentCard.PurchaseDate.substring(0, 10)) : null}
                                            onChange={val => setCurrentCard({ ...currentCard, PurchaseDate: val.local("en").format("YYYY-MM-DD") })} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>محل/اپراتور تولید: </td>
                                    <td colSpan={3}><input className="tableRowInput" placeholder="محل تولید" defaultValue={currentCard.Manufacturer ?? ""} onChange={e => currentCard.Manufacturer = e.target.value} /></td>
                                    <td colSpan={3}><input className="tableRowInput" placeholder="اپراتور تولید" defaultValue={currentCard.ProductionOperator ?? ""} onChange={e => currentCard.ProductionOperator = e.target.value} /></td>
                                </tr>
                                <tr>
                                    <td title="شناسه رهگیری وزارت صنعت، معدن و تجارت">شناسه رهگیری: </td>
                                    <td colSpan="100%"><input className="tableRowInput" defaultValue={currentCard.MIMTTrackingID ?? ""} onChange={e => currentCard.MIMTTrackingID = e.target.value} /></td>
                                </tr>
                                {Number(currentCard.CardID) > 0 &&
                                    <Fragment>
                                        <tr>
                                            <td>ابطال گارانتی: </td>
                                            <td><input className="form-check-input" type="checkbox" defaultChecked={currentCard.IsGuaranteeCanceled ?? ""} onChange={e => currentCard.IsGuaranteeCanceled = e.target.checked} /></td>
                                        </tr>
                                        <tr>
                                            <td>شرح ابطال: </td>
                                            <td colSpan="100%"><input className="tableRowInput" defaultValue={currentCard.CancelDescription ?? ""} onChange={e => currentCard.CancelDescription = e.target.value} /></td>
                                        </tr>
                                    </Fragment>
                                }
                                {!(Number(currentCard.InvoiceID) > 0) && !currentCard.IsUsedInServices && !currentCard.IsActive &&
                                    <tr>
                                        <td>انبار ثبت رسید:</td>
                                        <td colSpan="100%">
                                            <div>
                                                <input className="tableRowInput" onKeyDown={showModalStorage} value={currentCard.StorageName ?? ""} readOnly />
                                                <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalStorage}><List size={17} /></Button>
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        <div className="mt-2">
                            {cancelConfirm && <Alert variant="warning">
                                <span>
                                    <ExclamationTriangle size={18} />&nbsp;
                                    آیا از ابطال گارانتی مطمئن هستید؟
                                    <Button className="group-Btn-smalll" variant="success" onClick={() => addEdit(true)}><CheckLg size={18} /> بله</Button>
                                    <Button className="group-Btn-smalll" variant="danger" onClick={() => setCancelConfirm(false)}><DashCircle size={18} /> خیر</Button>
                                </span>
                            </Alert>}
                            {!cancelConfirm &&
                                <Button className="group-Btn" variant="success" onClick={() => addEdit()}>
                                    {Number(currentCard.CardID) > 0 ?
                                        <Fragment>
                                            <Pencil size={16} />&nbsp;ویرایش کارت
                                        </Fragment> :
                                        <Fragment>
                                            <CheckLg size={16} />&nbsp;ثبت کارت
                                        </Fragment>
                                    }
                                </Button>
                            }
                        </div>
                    </Popover.Content>
                </Popover>
            }
            <Card style={{ textAlign: "right" }}>
                {
                    exlModalInfo &&
                    <ModalImportFromExcel show={showImportExl} setShow={setShowImportExl}
                        submitData={exlModalInfo.submitData}
                        pageFields={exlModalInfo.pageFields}
                        formName={exlModalInfo.formName} />
                }
                <ModalGuaranteeSubProducts popData={modalSubProducts} setPopData={setModalSubProducts} productGrouppingType={pgType} />
                <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faClipboardList} size="lg" />&nbsp;
                    مدیریت کارت های گارانتی
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <FormGroup className="col-md-2 mt-0">
                        <label>نام برند: </label>
                        {
                            Array.isArray(holderList ?? "") ?
                                <select className="tableRowInput" onChange={e => currentHolder.current = e.target.value}>
                                    <option value="">انتخاب کنید</option>
                                    {holderList.map((item, i) =>
                                        <option key={i} value={item.ID}>{item.HolderName}</option>)
                                    }
                                </select> :
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                        }
                    </FormGroup>
                    <form readOnly onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder mt-3">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>نام/نوع کالا: </label>
                                <input className="search-input" name="ProductName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مدل کالا: </label>
                                <input className="search-input" name="ProductModel" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره گارانتی: </label>
                                <input className="search-input" name="GuaranteeCardNo" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره سریال: </label>
                                <input className="search-input" name="SerialNumber" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام فروشگاه: </label>
                                <input className="search-input" name="ShopName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره سریال قطعه:</label>
                                <input className="search-input" name="SubProductSerial" ref={register({})} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ ثبت از">تاریخ ثبت از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreateFromDate"
                                    onChange={value => dateFilters.current.CreateFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ ثبت تا">تاریخ ثبت تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreateToDate"
                                    onChange={value => dateFilters.current.CreateToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="آغاز گارانتی از">آغاز گارانتی از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeStartFromDate"
                                    onChange={value => dateFilters.current.GuaranteeStartFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="آغاز گارانتی تا">آغاز گارانتی تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeStartToDate"
                                    onChange={value => dateFilters.current.GuaranteeStartToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="پایان گارنتی از">پایان گارانتی از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeEndFromDate"
                                    onChange={value => dateFilters.current.GuaranteeEndFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="پایان گارانتی تا">پایان گارانتی تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="GuaranteeEndToDate"
                                    onChange={value => dateFilters.current.GuaranteeEndToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ فروش از">تاریخ فروش از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ActiveFromDate"
                                    onChange={value => dateFilters.current.ActiveFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ فروش تا">تاریخ فروش تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ActiveToDate"
                                    onChange={value => dateFilters.current.ActiveToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ خرید از">تاریخ خرید از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="PurchaseFromDate"
                                    onChange={value => dateFilters.current.PurchaseFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "4px" : "unset" }}>
                                <label className="ellipsisLabel" title="تاریخ خرید تا">تاریخ خرید تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="PurchaseToDate"
                                    onChange={value => dateFilters.current.PurchaseToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت استفاده: </label>
                                <select className="search-input" name="IsUsedInService" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>استفاده نشده</option>
                                    <option value={true}>استفاده شده</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت کارت: </label>
                                <select className="search-input" name="CardStatus" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={1}>عادی</option>
                                    <option value={2}>لیست سیاه</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label title="شناسه رهگیری وزارت صنعت، معدن و تجارت">شناسه رهگیری:</label>
                                <input className="search-input" name="MIMTTrackingID" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت فروش: </label>
                                <select className="search-input" name="IsActive" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>فروش نرفته</option>
                                    <option value={true}>فروش رفته</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت ابطال: </label>
                                <select className="search-input" name="IsCanceled" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>گارانتی معتبر</option>
                                    <option value={true}>خارج از گارانتی</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label >محل تولید:</label>
                                <input className="search-input" name="Manufacturer" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>اپراتور تولید:</label>
                                <input className="search-input" name="ProductionOperator" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">مرتب سازی براساس:</label>
                                <select className="search-input" name="OrderBy" ref={register({})}>
                                    <option value="CREATE">تاریخ ثبت-صعودی</option>
                                    <option value="CREATE DESC">تاریخ ثبت-نزولی</option>
                                    <option value="ACTIVE">تاریخ فعالسازی-صعودی</option>
                                    <option value="ACTIVE DESC">تاریخ فعالسازی-نزولی</option>
                                    <option value="SERIAL">سریال-صعودی</option>
                                    <option value="SERIAL DESC">سریال-نزولی</option>
                                    <option value="CARDNO">شماره کارت-صعودی</option>
                                    <option value="CARDNO DESC">شماره کارت-نزولی</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه: </label>
                                <select className="tableRowInput" name="Take" ref={register({})}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>
                                    <option value={1000}>1000</option>

                                </select>
                            </Col>
                        </Row>
                        <div className="mt-1">
                            <Button type="submit" className="group-Btn" variant="secondary"><Search size={18} />&nbsp;جستجوی کارت </Button>
                            <Button className="group-Btn" onClick={assignToAgency}><Reply size={18} />&nbsp;تخصیص کارتها به نماینده</Button>
                            <Button className="group-Btn" variant="info" onClick={prepareForAddEdit}><PlusCircle size={18} />&nbsp; ثبت کارت جدید</Button>
                            <Button className="group-Btn" variant="danger" onClick={deleteSelectedCards}><DashCircle size={18} />&nbsp; حذف کارتهای انتخاب شده</Button>
                            <Button className="group-Btn" onClick={showModalImportExl}><FileEarmarkX size={18} />&nbsp; دریافت از اکسل</Button>
                            <Button className="group-Btn btn-violet" onClick={showModalImportExlForSub}><FileEarmarkX size={18} />&nbsp; دریافت قطعات از اکسل</Button>
                        </div>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable filterData={filterData} searchMethod={(data) => dispatch(searchCards(data))} columns={tableCols} rowButtons={rowButtons}
                        reducerName="guaranteeCardsReducer" objectName="gCardSearchList" hasPaging className="mt-0" style={{ whiteSpace: "nowrap" }} />
                </Card.Body>
            </Card>
        </div >
    )
}
export default GuaranteeCardsManagement;